import { Box, Switch, Tooltip } from '@optiaxiom/react';

import type { ToolStatusToggleProps } from './types';

export function ToolStatusToggle({ tool, onToggleActive }: ToolStatusToggleProps) {
  return (
    <Tooltip content="System tools cannot be disabled" disabled={!tool.is_system_function}>
      <Box>
        <Switch
          disabled={tool.is_system_function}
          checked={!tool.is_disabled}
          onCheckedChange={() => onToggleActive(tool.function_id, tool.name, tool.is_disabled)}
          aria-label={`Toggle ${tool.name} active state`}
        />
      </Box>
    </Tooltip>
  );
}
